import React, { useEffect } from 'react';
// @ts-ignore
import styles from './LaboratoryRequestCreateFormSamples.module.scss';
import { LaboratoryRequestSample } from '../../Interfaces/LaboratoryRequestSample.interface';
import { joinClasses } from '../../../../Utils/className.util';

interface Props {
	activeSamples: string[];
	items: LaboratoryRequestSample[];
}

const LaboratoryRequestCreateFormSamples: React.FC<Props> = ({
	items,
	activeSamples,
}) => {
	return (
		<div className={styles.wrapper}>
			{items.map((item, key) => (
				<div
					className={joinClasses([
						styles.item,
						activeSamples.includes(item.key) ? styles.active : '',
					])}
					key={key}>
					({item.key}) {item.name}
				</div>
			))}
		</div>
	);
};

export default LaboratoryRequestCreateFormSamples;
